import { Alert, Button, Card, Empty, Space, Tag, Typography } from 'antd';
import { formatPrice } from '../utils/checkoutPricing';
import { resolveCreditOutputEstimates } from '../utils/creditEstimate';

const BillingCreditPackSection = ({
  canPurchaseCreditPacks,
  creditPackBlockHint,
  creditPackAnnualUpgradePlan,
  creditPackMonthlyUpgradePlan,
  creditPackAnnualUpgradeLabel,
  creditPackMonthlyUpgradeLabel,
  actionLoading,
  actionPlanId,
  onCheckout,
  onScrollToCreditPacks,
  onRefreshCreditPacks,
  creditPacksLoading,
  creditPacks,
  toNonNegativeInt,
  formatCreditPackUnitPrice,
  creditPackActionLoading,
  creditPackActionPackId,
  onCreditPackCheckout,
}) => (
  <Card
    id="billing-credit-packs"
    className="billing-card"
    title="购买积分"
    extra={(
      <Space size={8}>
        <Button type="primary" onClick={onScrollToCreditPacks}>
          购买积分
        </Button>
        <Button type="link" onClick={onRefreshCreditPacks} loading={creditPacksLoading}>
          刷新
        </Button>
      </Space>
    )}
  >
    <Space direction="vertical" size={12} style={{ width: '100%' }}>
      {canPurchaseCreditPacks ? (
        <Alert
          type="success"
          showIcon
          message="可直接补充创作积分"
          description="当每月赠送积分不够时，可额外购买积分包补足内容生产消耗。"
        />
      ) : (
        <Alert
          type="info"
          showIcon
          message="积分包仅对月会员与年会员开放"
          description={creditPackBlockHint}
        />
      )}
      {!canPurchaseCreditPacks && (creditPackAnnualUpgradePlan || creditPackMonthlyUpgradePlan) ? (
        <Space wrap size={10} className="billing-upgrade-cta-group">
          {creditPackAnnualUpgradePlan ? (
            <Button
              type="primary"
              className="billing-upgrade-cta-btn"
              loading={actionLoading && actionPlanId === String(creditPackAnnualUpgradePlan?.plan_id || '')}
              onClick={() => onCheckout(creditPackAnnualUpgradePlan)}
            >
              {creditPackAnnualUpgradeLabel}（推荐）
            </Button>
          ) : null}
          {creditPackMonthlyUpgradePlan ? (
            <Button
              className="billing-upgrade-cta-btn billing-upgrade-cta-btn--secondary"
              loading={actionLoading && actionPlanId === String(creditPackMonthlyUpgradePlan?.plan_id || '')}
              onClick={() => onCheckout(creditPackMonthlyUpgradePlan)}
            >
              {creditPackMonthlyUpgradeLabel}
            </Button>
          ) : null}
        </Space>
      ) : null}

      <div className="billing-pack-list billing-pack-list--inline">
        {(creditPacks || []).map((pack) => (
          <Card key={pack.pack_id} size="small" className="billing-pack-card" bodyStyle={{ padding: 14 }}>
            <Space direction="vertical" size={6} style={{ width: '100%' }}>
              <div className="billing-pack-card__title">
                <Typography.Text strong>{pack.name || pack.pack_id}</Typography.Text>
                <Tag color="gold">{toNonNegativeInt(pack.credits)} 积分</Tag>
              </div>
              <div className="plan-card__price">
                <span className="plan-card__currency">¥</span>
                <span className="plan-card__amount" style={{ fontSize: 24 }}>{formatPrice(pack.price_cents)}</span>
              </div>
              <Typography.Text type="secondary">
                {formatCreditPackUnitPrice(pack) || '按需补充积分'}
              </Typography.Text>
              <div className="billing-pack-card__estimates">
                <Typography.Text strong className="billing-pack-card__estimate-title">
                  大致可生成
                </Typography.Text>
                {resolveCreditOutputEstimates(pack?.credits).map((estimate) => (
                  <Typography.Text key={estimate.key} type="secondary" className="billing-pack-card__estimate-item">
                    {estimate.label}：{estimate.text}
                  </Typography.Text>
                ))}
              </div>
              <Button
                type="primary"
                block
                disabled={!canPurchaseCreditPacks}
                loading={creditPackActionLoading && creditPackActionPackId === String(pack.pack_id || '')}
                onClick={() => onCreditPackCheckout(pack)}
              >
                扫码购买
              </Button>
            </Space>
          </Card>
        ))}
      </div>
      {creditPacks && creditPacks.length > 0 ? (
        <Typography.Text type="secondary" className="billing-pack-note">
          以上为按当前默认计费规则的估算值：小红书笔记约 20 积分/篇，公众号文章约 30 积分/篇，标准短视频约 200 积分/条。实际消耗会随生产配置、素材复杂度和视频时长变化。
        </Typography.Text>
      ) : null}

      {!creditPacksLoading && (!creditPacks || creditPacks.length === 0) ? (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="暂无可购买积分包" />
      ) : null}
    </Space>
  </Card>
);

export default BillingCreditPackSection;
